import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useWebsiteSettings } from 'publisher/store'
import React from 'react'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { getWebsiteStylesTypographyHeading } from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonForm } from 'src/shared/entities/form'
import {
  FormInterface,
  FormSubentityTypeEnum,
} from 'src/shared/types/entities/form-interface'
import { FormProvider } from './context/form-context'
import { FormCheckboxSubentity } from './form-checkbox-subentity'
import { FormFieldSubentity } from './form-field'
import { FormSubmitButtonSubentity } from './form-submit-button-subentity'
import { useOptInSubmitForm } from './hooks/use-opt-in-submit-form'

export interface FormProps {
  entity: FormInterface
}

const BaseForm = ({ entity }: FormProps) => {
  const { calculatedFontSize } = useCalculateTypography({})
  const {
    fontSize: websiteGlobalHeadingFontSize,
    mobileFontSize: websiteGlobalMobileHeadingFontSize,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { isSuccess, isLoading, errors, onSubmit } = useOptInSubmitForm({
    formEntity: entity,
  })

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonForm
        entity={entity}
        successOptInScreen={{
          fontSize: calculatedFontSize.desktop,
          mobileFontSize: calculatedFontSize.mobile,
          headerFontSize: websiteGlobalHeadingFontSize,
          headerMobileFontSize: websiteGlobalMobileHeadingFontSize,
          textColor: entity.action.successOptInScreen?.textColor,
          mobileTextColor: entity.action.successOptInScreen?.mobileTextColor,
        }}
        isSuccessOptInScreenOpened={isSuccess}
      >
        {entity.subEntities.map(subentity => {
          if (subentity.type === FormSubentityTypeEnum.Field) {
            return (
              <FormFieldSubentity
                key={subentity.id}
                formEntity={entity}
                fieldSubentity={subentity}
              />
            )
          } else if (subentity.type === FormSubentityTypeEnum.Checkbox) {
            return (
              <FormCheckboxSubentity
                key={subentity.id}
                formEntity={entity}
                checkboxSubentity={subentity}
              />
            )
          } else if (subentity.type === FormSubentityTypeEnum.SubmitButton) {
            return (
              <FormSubmitButtonSubentity
                key={subentity.id}
                formEntity={entity}
                submitButtonSubentity={subentity}
                isLoading={isLoading}
                errors={errors}
                onSubmit={onSubmit}
              />
            )
          }
        })}
      </CommonForm>
    </StyleWrapper>
  )
}

export const Form = ({ entity }: FormProps) => {
  return (
    <FormProvider>
      <BaseForm entity={entity} />
    </FormProvider>
  )
}
